import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BookWidgetFieldUpdateTypes } from '../../../../constants/book-widget.constants';

import {
  BestFareOptionsMachCoreComponent,
  ConnectionPickerMachCoreComponent,
  DatePickerMachCoreComponent,
  MeetingCodeMachCoreComponent,
  MulticityRoutePickerMachCoreComponent,
  OptionsExpanderMachCoreComponent,
  SelectMachCoreComponent
} from '../../../common';

import { BookWidgetFieldUpdateEvent } from '../../../../models/book-widget-fields-update-info.interfaces';
import { ModifyBookWidgetBaseComponent } from '../modify-book-widget-base/modify-book-widget-base.component';
@Component({
  standalone: true,
  selector: 'idp-multi-city-mobile-modify',
  templateUrl: './multi-city-mobile-modify.component.html',
  imports: [
    CommonModule,
    BestFareOptionsMachCoreComponent,
    ConnectionPickerMachCoreComponent,
    DatePickerMachCoreComponent,
    MulticityRoutePickerMachCoreComponent,
    SelectMachCoreComponent,
    OptionsExpanderMachCoreComponent,
    MeetingCodeMachCoreComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MulticityMobileModifyComponent extends ModifyBookWidgetBaseComponent {
  clearConnectionAirport(flightIndex: number) {
    const emitValue: BookWidgetFieldUpdateEvent = {
      data: {
        airportCode: '',
        airportCity: '',
        flightIndex
      },
      type: BookWidgetFieldUpdateTypes.connectionAirport
    };
    this.bookWidgetFieldChange.emit(emitValue);
  }
}
